;(function(){
    /* Model */
    var ShowAttr = Backbone.Model.extend({
        urlRoot:APP_CONFIG.MEDIA_API_ROOT+"show_attributes/"
        ,parse:function(res){
	        if(res.results){
		        return res.results;
			}else{
				return res;
		    }
        }
    })
    
    
    /* Collection */
    var Collection = Backbone.Collection.extend({
         model  : ShowAttr
        ,url    : function(){
	        var type = (this.type)?"/"+this.type:"";
            return APP_CONFIG.MEDIA_API_ROOT+"show_attributes/"+this.programId+"/program"+type;
        }
        ,initialize:function(models,opts){
            if(opts && opts.programId){ this.programId=opts.programId; }
            if(opts && opts.type){ this.type=opts.type; }
        }
        ,parse  : function(data){
	        return data.results;
        }
    })


/* 
    API

    Use: Backbone.Radio.channel('entities').request('shows')
    
    These return a promise, so you'll want to wrap them in a $.when or something. 
    e.g. 
    $.when( Backbone.Radio.channel('entities').request('shows') )
        .done(function(data){ 
            console.log('d',data) 
        })
*/ 
    var api = Backbone.Radio.channel('entities');

    //get a single item
    api.reply('show_attr',function(id){
        var defer = $.Deferred()
            ,item;
            
        if(id){ 
	        item = new ShowAttr({'id':id})
	        item.fetch({
	            success:function(data){
	                defer.resolve(data)
	            }
	            ,error:function(data){
	                defer.resolve(undefined)
	            }
	        })
        }else{ //sometimes we just want a new object of the correct type
	       	item = new ShowAttr()
	    	defer.resolve(item) 
        }
        return defer.promise();
    })
    
    //get a collection
    api.reply('show_attrs',function(opts){
        opts = opts || {};
        var defer = $.Deferred()
            ,item = new Collection([],opts)
        item.fetch({
            success:function(data){
                defer.resolve(data)
            }
            ,error:function(data){
                defer.resolve(undefined)
            }
        })
        return defer.promise();
    })
})();